export default Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
